/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FCAFuelSurchargeValuesInput
 */
export interface FCAFuelSurchargeValuesInput {
  /**
   *
   * @type {string}
   * @memberof FCAFuelSurchargeValuesInput
   */
  fuelSurchargeIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof FCAFuelSurchargeValuesInput
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof FCAFuelSurchargeValuesInput
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the FCAFuelSurchargeValuesInput interface.
 */
export function instanceOfFCAFuelSurchargeValuesInput(
  value: object,
): value is FCAFuelSurchargeValuesInput {
  if (
    !("fuelSurchargeIdentifier" in value) ||
    value["fuelSurchargeIdentifier"] === undefined
  )
    return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function FCAFuelSurchargeValuesInputFromJSON(
  json: any,
): FCAFuelSurchargeValuesInput {
  return FCAFuelSurchargeValuesInputFromJSONTyped(json, false);
}

export function FCAFuelSurchargeValuesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FCAFuelSurchargeValuesInput {
  if (json == null) {
    return json;
  }
  return {
    fuelSurchargeIdentifier: json["fuelSurchargeIdentifier"],
    value: json["value"],
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function FCAFuelSurchargeValuesInputToJSON(
  json: any,
): FCAFuelSurchargeValuesInput {
  return FCAFuelSurchargeValuesInputToJSONTyped(json, false);
}

export function FCAFuelSurchargeValuesInputToJSONTyped(
  value?: FCAFuelSurchargeValuesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fuelSurchargeIdentifier: value["fuelSurchargeIdentifier"],
    value: value["value"],
    notes: value["notes"],
  };
}
